import {
    Button,
    FormHelperText,
    Grid,
    MenuItem,
    Select,
    styled,
} from '@mui/material';
import AppModal from 'components/AppModal';
import FlexBox from 'components/flexbox/FlexBox';
import AppTextField from 'components/input-fields/AppTextField';
// import ImageUploadInput from "components/input-fields/ImageUploadInput";
import { H2, H6 } from 'components/Typography';
import { useEffect, useState } from 'react';
import axiosInstance from 'utils/axios';

// styled components
const StyledAppModal = styled(AppModal)(({ theme }) => ({
    maxWidth: 600,
    minWidth: 450,
    [theme.breakpoints.down(325)]: {
        maxWidth: '100%',
    },
}));

const FormEditPrice = ({ open, onClose, data, onSuccessSubmit }) => {
    const [invoice_amount, setInvoiceAmount] = useState();

    const handleSubmit = async () => {
        await axiosInstance
            .patch(`api/register-group-details/${data.id}`, { invoice_amount })
            .then(() => onSuccessSubmit())
            .catch((err) => console.log(err));
    };
    return (
        <StyledAppModal open={open} handleClose={onClose}>
            <H2 mb={2}> Edit Invoice Amount</H2>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <AppTextField
                        fullWidth
                        size="small"
                        value={invoice_amount}
                        onChange={(e) => setInvoiceAmount(e.target.value)}
                    />
                </Grid>
            </Grid>
            <FlexBox justifyContent="flex-end" gap={2} marginTop={4}>
                <Button
                    fullWidth
                    size="small"
                    variant="outlined"
                    onClick={onClose}
                >
                    Cancel
                </Button>
                <Button
                    fullWidth
                    size="small"
                    variant="contained"
                    onClick={handleSubmit}
                >
                    Save
                </Button>
            </FlexBox>
        </StyledAppModal>
    );
};

export default FormEditPrice;
